<div class="content-wrapper p-0">
	<app-content-header [contentHeader]="contentHeader"></app-content-header>
	<div class="content-body">
		<section class="app-ecommerce-details">
			<div class="card">
				<div class="bs-stepper horizontal-wizard-example">
					<div class="bs-stepper-header">
						<b>Progress Report</b>
					</div>
					<div class="bs-stepper-content">
						<form [formGroup]="progressReportForm" autocomplete="off">
							<fieldset class="border" style="padding: 0.7rem;">
								<legend class="w-auto">
									<h5 style="margin-top: 7px;">Proposal Information</h5>
								</legend>
								<div class="row">
									<div class="form-group col-md-4">
										<label class="form-label" for="projectTitle">Project Title</label>
										<input formControlName="Projecttitles" type="text" name="Projecttitles"
											id="Projecttitles" class="form-control" placeholder="Project Title"
											[(ngModel)]="projectTitle" readonly />
									</div>
									
									<div class="form-group col-md-4">
										<label class="form-label" for="nameOfPi">Name of PI</label>
										<input formControlName="nameOfPi" type="text" name="nameOfPi" id="nameOfPi"
											class="form-control" placeholder="Name" [(ngModel)]="principleInvestigator"
											readonly />
									</div>
									<div class="form-group col-md-4">
										<label class="form-label" for="addressOfPi">Complete Address of PI<span
												class="required-asterisk">*</span></label>
										<input formControlName="addressOfPi" type="text" name="addressOfPi"
											id="addressOfPi" class="form-control" placeholder="Address"
											[ngClass]="{ 'is-invalid': submitted && !formDetails.addressOfPi.valid }" />
										<span *ngIf="submitted && formDetails.addressOfPi.invalid" class="invalid-form">
											<small class="form-text text-danger"
												*ngIf="formDetails.addressOfPi.errors.required">This
												field is required!</small>
										</span>
									</div>
								</div>
								<div class="row">
									<div class="form-group col-md-4">
										<label class="form-label" for="projectstartDate">Project Start Date</label>
										<fieldset class="form-group">
											<div class="input-group">
												<input class="form-control" placeholder="dd-mm-yyyy" name="projectstartDate"
													formControlName="projectstartDate" ngbDatepicker #disabledDP="ngbDatepicker" [disabled]="true"/>
												<div class="input-group-append">
													<button class="btn btn-outline-secondary feather icon-calendar"
													(click)="disabledDP.toggle()" type="button"
														rippleEffect></button>
												</div>
											</div>
										</fieldset>
									</div>
									<div class="form-group col-md-4">
										<label class="form-label" for="projectendDate">Project End Date</label>
											<fieldset class="form-group">
												<div class="input-group">
													<input class="form-control" placeholder="dd-mm-yyyy" name="projectendDate"
														formControlName="projectendDate" ngbDatepicker #disabledDP1="ngbDatepicker" [disabled]="true"/>
													<div class="input-group-append">
														<button class="btn btn-outline-secondary feather icon-calendar"
														(click)="disabledDP1.toggle()" type="button"
															rippleEffect></button>
													</div>
												</div>
											</fieldset>
										<span *ngIf="submitted && formDetails.projectendDate.invalid"
											class="invalid-form">
											<small class="form-text text-danger"
												*ngIf="formDetails.projectendDate.errors.required">This
												field is required!</small>
										</span>

									</div>
									
								</div>
							</fieldset>
							
							<fieldset class="border" style="padding: 0.7rem;">
								<legend class="w-auto">
									<h5 style="margin-top: 7px;">Total funds sanctioned/released by MNRE</h5>
								</legend>
								<div class="row">
									<div class="col-md-12">
										<fieldset class="border" style="padding: 0.7rem;">
											<legend class="w-auto">
												<h5 style="margin-top: 7px;">Sanctioned details</h5>
											</legend>
											<div class="row">
												<div class=" form-group col-md-4">
													<label class="form-label" for="sanctionOrder">Sanction Order No.</label>
													<input formControlName="sanctionOrderNo" type="text" name="sanctionOrderNo"
														id="sanctionOrderNo" class="form-control" placeholder="Sanction Order No."
														[(ngModel)]="orderNo" readonly />
												</div>
												<div class="form-group col-md-4">
													<label class="form-label" for="sanctionOrder">Sanction order Date</label>
													<fieldset class="form-group">
														<div class="input-group">
															<input class="form-control" placeholder="dd-mm-yyyy" name="sanctionOrderDate"
																formControlName="sanctionOrderDate" ngbDatepicker #disabledDP2="ngbDatepicker" [disabled]="true"/>
															<div class="input-group-append">
																<button class="btn btn-outline-secondary feather icon-calendar"
																(click)="disabledDP2.toggle()" type="button"
																	rippleEffect></button>
															</div>
														</div>
													</fieldset>
												</div>
												<div class="form-group col-md-4">
													<label class="form-label" for="sanctionAmount">Sanctioned Amount (Rs.)</label>
													<input formControlName="sanctionAmount" type="text" name="sanctionAmount"
														id="sanctionAmount" class="form-control"
														placeholder="Sanctioned Amount" [(ngModel)]="sanctionAmount" readonly />
												</div>
											</div>
										</fieldset>
									</div>
								</div>
								<div class="row">
									<div class="col-md-12">
										<fieldset class="border" style="padding: 0.7rem;">
											<legend class="w-auto">
												<h5 style="margin-top: 7px;">Released by MNRE</h5>
											</legend>
											<!-- this.releasedReportDetails -->
											<div *ngFor="let item of releasedReportDetails">
												<div class="row">
													<div class="form-group col-md-4">
														<label class="form-label" for="projectTitle">Released Order No.</label>
														<input class="form-control" type="text" readonly value={{item.releasedOrderNo}} />
													</div>
													<div class=" form-group col-md-4">
														<label class="form-label" for="sanctionOrder">Released Date</label>
														<fieldset class="form-group">
															<div class="input-group">
																<input class="form-control" placeholder="dd-mm-yyyy"
																	 ngbDatepicker #disabledDP3="ngbDatepicker" [disabled]="true" value={{item.releasedDate}}/>
																<div class="input-group-append">
																	<button class="btn btn-outline-secondary feather icon-calendar"
																	(click)="disabledDP3.toggle()" type="button" rippleEffect></button>
																</div>
															</div>
														</fieldset>
													</div>
													<div class="form-group col-md-4">
														<label class="form-label" for="releasedAmount">Released Amount (Rs.)</label>
														<input class="form-control" type="text" value={{item.releasedAmount}}  [mask]="'^[+]?([1-9]\\d*|0)?(\\.\\d\{0,2\})?$'" [(ngModel)]="releasedAmount" [disabled]="true" readonly />
													</div>
												</div>
											</div>
										</fieldset>
									</div>
								</div>
							</fieldset>
							<fieldset class="border" style="padding: 0.7rem;">
								<legend class="w-auto">
									<h5 style="margin-top: 7px;"></h5>
								</legend>
								<div class="row">
									<div class="form-group col-md-4">
										<label class="form-label" for="actualExpenditure">Actual expenditure as on date
											enclosing SoE and UC <span class="required-asterisk">*</span></label>
										<input formControlName="actualExpenditure" type="text" name="actualExpenditure"
											id="actualExpenditure" class="form-control" placeholder="Actual expenditure"
											[ngClass]="{ 'is-invalid': submitted && !formDetails.actualExpenditure.valid }" />
										<span *ngIf="submitted && formDetails.actualExpenditure.invalid"
											class="invalid-form">
											<small class="form-text text-danger"
												*ngIf="formDetails.actualExpenditure.errors.required">This
												field is required!</small>
										</span>
									</div>
									<div class="form-group col-md-4">
										<label class="form-label" for="approvedObject">Approved Objectives of the
											Project <span class="required-asterisk">*</span></label>
										<input formControlName="approvedObject" type="text" name="approvedObject"
											id="approvedObject" class="form-control"
											placeholder="Approved Objectives of the Project"
											[ngClass]="{ 'is-invalid': submitted && !formDetails.approvedObject.valid }" />
										<span *ngIf="submitted && formDetails.approvedObject.invalid"
											class="invalid-form">
											<small class="form-text text-danger"
												*ngIf="formDetails.approvedObject.errors.required">This
												field is required!</small>
										</span>
									</div>
									<div class="form-group col-md-4">
										<label class="form-label" for="outputProject">Output of the approved
											Project <span class="required-asterisk">*</span></label>
										<input formControlName="outputProject" type="text" name="outputProject"
											id="outputProject" class="form-control"
											placeholder="Output of the approved Project"
											[ngClass]="{ 'is-invalid': submitted && !formDetails.outputProject.valid }" />
										<span *ngIf="submitted && formDetails.outputProject.invalid"
											class="invalid-form">
											<small class="form-text text-danger"
												*ngIf="formDetails.outputProject.errors.required">This
												field is required!</small>
										</span>
									</div>
								</div>
								<div class="row">
									<div class="form-group col-md-6">
										<label class="form-label" for="summary">Summary of the Progress
											reported <span class="required-asterisk">*</span></label>
										<textarea formControlName="summary" type="text" name="summary" id="summary"
											class="form-control" placeholder="Summary" style="height:200px;"
											[ngClass]="{ 'is-invalid': submitted && !formDetails.summary.valid }"></textarea>
										<span *ngIf="submitted && formDetails.summary.invalid" class="invalid-form">
											<small class="form-text text-danger"
												*ngIf="formDetails.summary.errors.required">This
												field is required!</small>
										</span>
									</div>
									<div class="form-group col-md-6">
										<label class="form-label" for="detailedProgress">Detailed Progress <span
												class="required-asterisk">*</span></label>
										<textarea formControlName="detailedProgress" type="text" name="detailedProgress"
											id="detailedProgress" class="form-control" placeholder="Detailed Progress" style="height:200px;"
											[ngClass]="{ 'is-invalid': submitted && !formDetails.detailedProgress.valid }"></textarea>
										<span *ngIf="submitted && formDetails.detailedProgress.invalid"
											class="invalid-form">
											<small class="form-text text-danger"
												*ngIf="formDetails.detailedProgress.errors.required">This
												field is required!</small>
										</span>
									</div>
								</div>
								<div class="row">
									<div class="form-group col-md-6 file-field md-form">
										<label class="form-label" for="technicalReport">Upload Technical Report</label> (Upload PDF of size upto 25MB)
										<!-- <span class="required-asterisk">*</span> -->
										<div class="custom-file">
											<input type="file" class="form-control custom-file-input" ng2FileSelect accept=".pdf"
												id="file-upload-single" (click)="browsbuttonClick('technicalReport')"
												(change)="uploadFileChangeTechnical($event, 25)"
												formControlName="technicalReport"
												[ngClass]="{ 'is-invalid': submitted && !formDetails.technicalReport.valid }" />
											<label class="custom-file-label" id="technicalReport"
												for="file-upload-single">{{formDetails.technicalReportName.value}}</label>
										</div>
										<span *ngIf="submitted && formDetails.technicalReport.invalid"
											class="invalid-form">
											<small class="form-text text-danger"
												*ngIf="formDetails.technicalReport.errors.required">This
												field is required!</small>
										</span>
									</div>
									<div class="form-group col-md-6 file-field md-form">
										<label class="form-label" for="otherDocument">Upload Other Document</label> (Upload PDF of size upto 25MB)
										<!-- <span class="required-asterisk">*</span> -->
										<div class="custom-file">
											<input type="file" class="form-control custom-file-input" ng2FileSelect
												id="file-upload-single" (click)="browsbuttonClick('otherDocument')" accept=".pdf"
												(change)="uploadFileChangeOther($event, 25)" formControlName="otherDocument"
												[ngClass]="{ 'is-invalid': submitted && !formDetails.otherDocument.valid }" />
											<label class="custom-file-label" id="otherDocument"
												for="file-upload-single">{{formDetails.otherDocumentName.value}}</label>
										</div>
										<span *ngIf="submitted && formDetails.otherDocument.invalid"
											class="invalid-form">
											<small class="form-text text-danger"
												*ngIf="formDetails.otherDocument.errors.required">This
												field is required!</small>
										</span>
									</div>
								</div>
							</fieldset>
							<fieldset class="border" style="padding: 0.7rem;">
								<legend class="w-auto">
									<h5 style="margin-top: 7px;">Status of Equipment Procurement</h5>
								</legend>
								<div class="row">
									<div class="form-group col-md-12">
										<form [formGroup]="equipmentProcurementForm" *ngIf="equipmentProcurementForm">
											<table class="table table-striped table-bordered">
												<thead>
													<tr>
														<th>Action</th>
														<th>Sanctioned items of equipment</th>
														<th>Procurement status (Yes/ No) Model & make, Date of
															procurement & commissioning</th>
														<th>Cost (Rs)</th>
														<th>Working (Yes/ No)</th>
														<th>Remarks (Give reasons for negative response)</th>
													</tr>
												</thead>
												<tbody formArrayName="equipmentProcurementArray">
													<tr *ngFor="let item of equipmentProcurementForm.controls.equipmentProcurementArray.controls; let $i=index"
														[formGroupName]="$i">
														<td (click)="deleteEquipmentRow($i)">
															<i class="fa fa-trash fa-2x"></i>
														</td>
														<td>
															<input class="form-control" type="text"
																formControlName="sanctionitem"
																placeholder="Sanctioned items of equipment "
																[ngClass]="{ 'is-invalid': equipmentProcurementForm.controls['equipmentProcurementArray'].controls[$i].controls['sanctionitem'].touched
                             												&& equipmentProcurementForm.controls['equipmentProcurementArray'].controls[$i].controls['sanctionitem'].invalid}" />
															<span
																*ngIf="equipmentProcurementForm.controls['equipmentProcurementArray'].controls[$i].controls['sanctionitem'].invalid"
																class="invalid-form">
																<small class="form-text text-danger"
																	*ngIf="equipmentProcurementForm.controls['equipmentProcurementArray'].controls[$i].controls['sanctionitem'].touched &&  equipmentProcurementForm.controls['equipmentProcurementArray'].controls[$i].controls['sanctionitem'].hasError('required')">
																	Required!
																</small>
															</span>
														</td>
														<td>
															<ng-select [items]="position" bindLabel="positionName" bindValue="positionName"
															[class.error]="equipmentProcurementForm.controls['equipmentProcurementArray'].controls[$i].controls['procurementStatus'].invalid"
															formControlName="procurementStatus" placeholder="(Yes/ No)"></ng-select>
															<span
																*ngIf="equipmentProcurementForm.controls['equipmentProcurementArray'].controls[$i].controls['procurementStatus'].invalid"
																class="invalid-form">
																<small class="form-text text-danger"
																	*ngIf="equipmentProcurementForm.controls['equipmentProcurementArray'].controls[$i].controls['procurementStatus'].touched &&  equipmentProcurementForm.controls['equipmentProcurementArray'].controls[$i].controls['procurementStatus'].hasError('required')">
																	Required!
																</small>
															</span>
														</td>
														<td>
															<input class="form-control" type="text"
																formControlName="cost" curencyFormat
																[mask]="'^[+]?([1-9]\\d*|0)?(\\.\\d\{0,2\})?$'"
																onKeyPress="if(this.value.length==15) return false;"
																[ngClass]="{ 'is-invalid': equipmentProcurementForm.controls['equipmentProcurementArray'].controls[$i].controls['cost'].touched
                             												&& equipmentProcurementForm.controls['equipmentProcurementArray'].controls[$i].controls['cost'].invalid}" />
															<span
																*ngIf="equipmentProcurementForm.controls['equipmentProcurementArray'].controls[$i].controls['cost'].invalid"
																class="invalid-form">
																<small class="form-text text-danger"
																	*ngIf="equipmentProcurementForm.controls['equipmentProcurementArray'].controls[$i].controls['cost'].touched &&  equipmentProcurementForm.controls['equipmentProcurementArray'].controls[$i].controls['cost'].hasError('required')">
																	Required!
																</small>
															</span>
														</td>
														<td>
															<ng-select [items]="position" bindLabel="positionName" bindValue="positionName"
															[class.error]="equipmentProcurementForm.controls['equipmentProcurementArray'].controls[$i].controls['workingOrNot'].invalid"
															formControlName="workingOrNot" placeholder="(Yes/ No)"></ng-select>
															<span *ngIf="equipmentProcurementForm.controls['equipmentProcurementArray'].controls[$i].controls['workingOrNot'].invalid"
																class="invalid-form">
																<small class="form-text text-danger"
																	*ngIf="equipmentProcurementForm.controls['equipmentProcurementArray'].controls[$i].controls['workingOrNot'].touched && 	equipmentProcurementForm.controls['equipmentProcurementArray'].controls[$i].controls['workingOrNot'].hasError('required')">
																	Required!
																</small>
															</span>
														</td>
														<td>
															<textarea formControlName="remarks" type="text"
																name="remarks" id="remarks" class="form-control"
																placeholder="Remarks "
																[ngClass]="{ 'is-invalid': equipmentProcurementForm.controls['equipmentProcurementArray'].controls[$i].controls['remarks'].touched
                             												&& equipmentProcurementForm.controls['equipmentProcurementArray'].controls[$i].controls['remarks'].invalid}"></textarea>
															<span
																*ngIf="equipmentProcurementForm.controls['equipmentProcurementArray'].controls[$i].controls['remarks'].invalid"
																class="invalid-form">
																<small class="form-text text-danger"
																	*ngIf="equipmentProcurementForm.controls['equipmentProcurementArray'].controls[$i].controls['remarks'].touched && equipmentProcurementForm.controls['equipmentProcurementArray'].controls[$i].controls['remarks'].hasError('required')">
																	Required!
																</small>
															</span>
														</td>
													</tr>
													<tr>
														<td (click)="addEquipmentRow()">
															<i class="fa fa-plus fa-2x"></i>
														</td>
													</tr>
												</tbody>
											</table>
										</form>
									</div>
								</div>
							</fieldset>
							<fieldset class="border" style="padding: 0.7rem;">
								<legend class="w-auto">
									<h5 style="margin-top: 7px;">Status of Manpower</h5>
								</legend>
								<div class="row">
									<div class="form-group col-md-12">
										<form [formGroup]="manpowerForm" *ngIf="manpowerForm">
											<table class="table table-striped table-bordered">
												<thead>
													<tr>
														<th>Action</th>
														<th>Sanctioned List</th>
														<th>In position (Yes/ No)</th>
														<th>Scale</th>
														<th>Remarks (Give reasons for negative response)</th>
													</tr>
												</thead>
												<tbody formArrayName="manpowerArray">
													<tr *ngFor="let item of manpowerForm.controls.manpowerArray.controls; let $in=index"
														[formGroupName]="$in">
														<td (click)="deleteManpowerRow($in)">
															<i class="fa fa-trash fa-2x"></i>
														</td>
														<td>
															<input class="form-control" type="text"
																formControlName="sanctionedlist"
																placeholder="Sanctioned List"
																[ngClass]="{ 'is-invalid': manpowerForm.controls['manpowerArray'].controls[$in].controls['sanctionedlist'].touched && manpowerForm.controls['manpowerArray'].controls[$in].controls['sanctionedlist'].invalid}" />
															<span
																*ngIf="manpowerForm.controls['manpowerArray'].controls[$in].controls['sanctionedlist'].invalid"
																class="invalid-form">
																<small class="form-text text-danger"
																	*ngIf="manpowerForm.controls['manpowerArray'].controls[$in].controls['sanctionedlist'].touched &&  manpowerForm.controls['manpowerArray'].controls[$in].controls['sanctionedlist'].hasError('required')">
																	Required!
																</small>
															</span>
														</td>
														<td>
																<ng-select [items]="position" bindLabel="positionName" bindValue="positionName"
																[class.error]="manpowerForm.controls['manpowerArray'].controls[$in].controls['position'].invalid"
																formControlName="position" placeholder="(Yes/ No)"></ng-select>

																<span
																*ngIf="manpowerForm.controls['manpowerArray'].controls[$in].controls['position'].invalid"
																class="invalid-form">
																<small class="form-text text-danger"
																	*ngIf="manpowerForm.controls['manpowerArray'].controls[$in].controls['position'].touched &&  manpowerForm.controls['manpowerArray'].controls[$in].controls['position'].hasError('required')">
																	Required!
																</small>
															</span>
														</td>
														<td>
															<input class="form-control" type="text"
																formControlName="scale"
																[ngClass]="{ 'is-invalid': manpowerForm.controls['manpowerArray'].controls[$in].controls['scale'].touched && manpowerForm.controls['manpowerArray'].controls[$in].controls['scale'].invalid}" />
															<span
																*ngIf="manpowerForm.controls['manpowerArray'].controls[$in].controls['scale'].invalid"
																class="invalid-form">
																<small class="form-text text-danger"
																	*ngIf="manpowerForm.controls['manpowerArray'].controls[$in].controls['scale'].touched &&  manpowerForm.controls['manpowerArray'].controls[$in].controls['scale'].hasError('required')">
																	Required!
																</small>
															</span>
														</td>
														<td>
															<textarea formControlName="manpowerRemarks" type="text"
																name="Remarks" id="manpowerRemarks"
																class="form-control" placeholder="Mapower Remarks "
																[ngClass]="{ 'is-invalid': manpowerForm.controls['manpowerArray'].controls[$in].controls['manpowerRemarks'].touched && manpowerForm.controls['manpowerArray'].controls[$in].controls['manpowerRemarks'].invalid}"></textarea>
															<span
																*ngIf="manpowerForm.controls['manpowerArray'].controls[$in].controls['manpowerRemarks'].invalid"
																class="invalid-form">
																<small class="form-text text-danger"
																	*ngIf="manpowerForm.controls['manpowerArray'].controls[$in].controls['manpowerRemarks'].touched && manpowerForm.controls['manpowerArray'].controls[$in].controls['manpowerRemarks'].hasError('required')">
																	Required!
																</small>
															</span>
														</td>
													</tr>
													<tr>
														<td (click)="addManpowerRow()">
															<i class="fa fa-plus fa-2x"></i>
														</td>
													</tr>
												</tbody>
											</table>
										</form>
									</div>
								</div>
							</fieldset>
							<fieldset class="border" style="padding: 0.7rem;">
								<legend class="w-auto">
									<h5 style="margin-top: 7px;"></h5>
								</legend>
								<div class="row">
									<div class="form-group col-md-6">
										<label class="form-label" for="newObservation">New Observations <span
												class="required-asterisk">*</span></label>
										<textarea formControlName="newObservation" type="text" name="newObservation"
										id="newObservation" class="form-control" placeholder="New observations" style="height: 200px"
										[ngClass]="{ 'is-invalid': submitted && !formDetails.newObservation.valid }"></textarea>
										<span *ngIf="submitted && formDetails.newObservation.invalid"
											class="invalid-form">
											<small class="form-text text-danger"
												*ngIf="formDetails.newObservation.errors.required">This
												field is required!</small>
										</span>
									</div>
									<div class="form-group col-md-6">
										<label class="form-label" for="innovations">Innovations <span
												class="required-asterisk">*</span></label>
									
											<textarea formControlName="innovations" type="text" name="innovations"
										id="innovations" class="form-control" placeholder="Innovations" style="height: 200px"
										[ngClass]="{ 'is-invalid': submitted && !formDetails.innovations.valid }"></textarea>

										<span *ngIf="submitted && formDetails.innovations.invalid" class="invalid-form">
											<small class="form-text text-danger"
												*ngIf="formDetails.innovations.errors.required">This
												field is required!</small>
										</span>
									</div>
								</div>
								<div class="row">
									<div class="form-group col-md-6">
										<label class="form-label" for="applicationPotential">Application
											Potential <span class="required-asterisk">*</span></label>
											<textarea formControlName="applicationPotential" type="text" name="applicationPotential"
											id="applicationPotential" class="form-control" placeholder="Application Potential" style="height: 200px"
											[ngClass]="{ 'is-invalid': submitted && !formDetails.applicationPotential.valid }"></textarea>
										<span *ngIf="submitted && formDetails.applicationPotential.invalid"
											class="invalid-form">
											<small class="form-text text-danger"
												*ngIf="formDetails.applicationPotential.errors.required">This
												field is required!</small>
										</span>
									</div>
									<div class="form-group col-md-6">
										<label class="form-label" for="projectWorkPlan">Research / Technology
											development
											work remaining to be done under the project and Work Plan for next six
											months. <span class="required-asterisk">*</span></label>
										<textarea formControlName="projectWorkPlan" type="text" name="projectWorkPlan"
											id="projectWorkPlan" class="form-control"  style="height: 200px"
											placeholder="Project and work Plan"
											[ngClass]="{ 'is-invalid': submitted && !formDetails.projectWorkPlan.valid }"></textarea>
										<span *ngIf="submitted && formDetails.projectWorkPlan.invalid"
											class="invalid-form">
											<small class="form-text text-danger"
												*ngIf="formDetails.projectWorkPlan.errors.required">This
												field is required!</small>
										</span>
									</div>
								</div>
							</fieldset>
							<fieldset class="border" style="padding: 0.7rem;">
								<legend class="w-auto">
									<h5 style="margin-top: 7px;">Financial Progress Report</h5>
								</legend>
								<div class="row">
									<div class="form-group col-md-4">
										<label class="form-label" for="financialStatus">Status of Financial Year wise UC
											and
											SoE</label>
										<textarea formControlName="financialStatus" type="text" name="financialStatus"
											id="financialStatus" class="form-control" style="height:200px;"
											placeholder="Status of Financial Year wise UC and SoE"></textarea>
									</div>
									<div class="form-group col-md-4 file-field md-form">
										<label class="form-label" for="orderNo">Upload UC letter </label><br />
										<sup>Upload PDF of size upto 25MB</sup>
										<!-- <span class="required-asterisk">*</span> -->
										<div class="custom-file">
											<input type="file" class="form-control custom-file-input" ng2FileSelect
												id="file-upload-single" (click)="browsbuttonClick('UCLatter')" accept=".pdf"
												(change)="uploadFileChange($event, 25)" formControlName="UCLatter"
												[ngClass]="{ 'is-invalid': submitted && !formDetails.UCLatter.valid }" />
											<label class="custom-file-label" id="UCLatter"
												for="file-upload-single">{{formDetails.UCLatterName.value}}</label>
										</div>
										<span *ngIf="submitted && formDetails.UCLatter.invalid" class="invalid-form">
											<small class="form-text text-danger"
												*ngIf="formDetails.UCLatter.errors.required">This
												field is required!</small>
										</span>
									</div>
									<div class="form-group col-md-4 file-field md-form">
										<label class="form-label" for="orderNo">Upload SOE letter  </label><br />
										<sup>Upload PDF of size upto 25MB</sup>
										<!-- <span class="required-asterisk">*</span> -->
										<div class="custom-file">
											<input type="file" class="form-control custom-file-input" ng2FileSelect
												id="file-upload-single" (click)="browsbuttonClick('SOELatter')" accept=".pdf"
												(change)="uploadFileChangeSOE($event, 25)" formControlName="SOELatter"
												[ngClass]="{ 'is-invalid': submitted && !formDetails.SOELatter.valid }" />
											<label class="custom-file-label" id="SOELatter"
												for="file-upload-single">{{formDetails.SOELatterName.value}}</label>
										</div>
										<span *ngIf="submitted && formDetails.SOELatter.invalid" class="invalid-form">
											<small class="form-text text-danger"
												*ngIf="formDetails.SOELatter.errors.required">This
												field is required!</small>
										</span>
									</div>
								</div>
							</fieldset>
							<div *ngIf="reportDetails == undefined">
								<span>
									<div class="d-flex justify-content-between submitbtn">
										<button class="btn btn-success btn-submit" (click)="saveProgressReportData()"
											rippleEffect>Submit</button>
									</div>
								</span>
							</div>
							<div *ngIf="reportDetails != undefined">
								<span
									*ngIf="(reportDetails.status == progressReportStatus.approve || reportDetails.status == progressReportStatus.reject)">
									<div class="d-flex justify-content-between submitbtn">
										<button class="btn btn-success btn-submit" (click)="saveProgressReportData()"
											rippleEffect>Submit</button>
									</div>
								</span>
							</div>
							<div *ngIf="reportDetails != undefined">
								<span
									*ngIf="(reportDetails.id && reportDetails.status == progressReportStatus.pending)">
									<div class="d-flex alert-info mt-1 notecss">
										Note* Review report is pending for review at MNRE.
									</div>
								</span>
							</div>
						</form>
					</div>
				</div>
			</div>
			<!-- Related Products starts -->
		</section>
	</div>
</div>